export default "__VITE_ASSET__b2f3ef3e__"